import React from 'react';
import { Col, Row } from 'antd';
import { translate } from '@portal/services/i18n';
import './MaintenanceScreen.less';

const MaintenanceScreen = () => {
  return (
    <div className="maintenance-screen">
      <Row
        justify="center"
        align="middle"
        className="maintenance-screen__container"
      >
        <Col xs={24} sm={20} md={16} lg={12} xl={8}>
          <div className="maintenance-screen__content">
            <div className="maintenance-screen__icon">
              <img
                src="/assets/svg/maintenance.svg"
                alt="Manutenção"
                width="80"
                height="80"
              />
            </div>

            <h1 className="maintenance-screen__title">
              {translate('COMPONENTS.MAINTENANCE.TITLE')}
            </h1>

            <p className="maintenance-screen__description">
              {translate('COMPONENTS.MAINTENANCE.MESSAGE')}
            </p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MaintenanceScreen;
